export default __webpack_public_path__ + "static/media/slider1.8c19ee09.jpg";